import rootReducer from 'reducers';
import { applyMiddleware, createStore } from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

const userTiming = () => next => action => {
  if (performance.mark === undefined) return next(action);
  performance.mark(`${action.type}_start`);
  const result = next(action);
  performance.mark(`${action.type}_end`);
  performance.measure(
    `${action.type}`,
    `${action.type}_start`,
    `${action.type}_end`
  );
  return result;
};

const configureStore = () => {
  const middlewares = [apiMiddleware, thunk, userTiming];
  const componseEnhancers = composeWithDevTools({ trace: true });

  return createStore(
    rootReducer,
    componseEnhancers(applyMiddleware(...middlewares))
  );
};

export default configureStore;
